
            const data = {"name":"feather/mail","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\"/><path pid=\"1\" d=\"m22 6-10 7L2 6\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                